export default "__VITE_ASSET__BKwqbboz__"